import { useEffect } from 'react';

export const useMetaDescription = (description?: string) => {
  useEffect(() => {
    if (!description) return;

    const ensureTag = (selector: string, attrName: 'name' | 'property', attrValue: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(selector);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attrName, attrValue);
        document.head.appendChild(tag);
      }
      return tag;
    };

    const descTag = ensureTag('meta[name="description"]', 'name', 'description');
    const ogDescTag = ensureTag('meta[property="og:description"]', 'property', 'og:description');
    const twDescTag = ensureTag('meta[name="twitter:description"]', 'name', 'twitter:description');

    descTag.setAttribute('content', description);
    ogDescTag.setAttribute('content', description);
    twDescTag.setAttribute('content', description);
  }, [description]);
};
